import { MutationTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { CartState } from '@/store/modules/cart/state';
import { CartModel } from '@/models/CartModel';
import { CheckoutModel } from '@/models/CheckoutModel';
import moment from 'moment';

const mutations: MutationTree<CartState> = {

  [ActionTypes.CartInfo](state: CartState, cart: CartModel) {
    state.cart = cart;
  },

  [ActionTypes.AddCart](state: CartState, cart: CartModel) {
    state.cart = cart;
  },

  [ActionTypes.EditCart](state: CartState, cart: CartModel) {
    state.cart = cart;
  },

  [ActionTypes.EmptyCart](state: CartState) {
    state.cart = null;
  },

  [ActionTypes.RemoveCartItem](state: CartState, cart: CartModel) {
    state.cart = cart;
  },

  [ActionTypes.AddCartTip](state: CartState, cart: CartModel) {
    state.cart = cart;
  },

  [ActionTypes.RemoveCartTip](state: CartState, cart: CartModel) {
    state.cart = cart;
  },

  [ActionTypes.Checkout](state: CartState, checkout: CheckoutModel) {
    state.checkout = checkout;
  },

  [ActionTypes.SetPickupDateTime](state: CartState, pickupDateTime: moment.Moment | null) {
    state.pickupDateTime = pickupDateTime;
  },

};

export default mutations;
